import React, { Component } from 'react'
import CardPartido from '../CardPartido'
import './_styles.scss'
import Asset from '../../../../../requests/apa/Asset'
import Utils from '../../../../../utils/Utils'
import Translator from '../../../../../requests/apa/Translator'
import { getCommonNextMatchId } from '../../../utils'

class EliminatoriasContent extends Component {
  getTitles = (direction, phase) => {
    if(direction === 'left'){
      return Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_titulo1_${phase}`), 22)
    } else {
      return Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_titulo2_${phase}`), 22)
    }
  }

  renderMatches(round) {
    const { path, liveEventsMap = {}, liveScoresMap = {} } = this.props
    if (!round || !Array.isArray(round) || round.length < 1) return null

    return round && round.map((item, index) => {
      const match = item
      return (
        <div className='eliminatorias-content__match-wrapper' key={index}>
          { match && (
            <CardPartido
              time={match.time}
              timezone={match.timezone}
              homeTeam={match.homeTeam}
              awayTeam={match.awayTeam}
              venue={match.venue}
              status={match.status}
              matchId={match.id}
              scheduledAt={match.scheduledAt}
              broadcast={match.broadcast}
              matchProgress={match.matchProgress}
              customClass={`main-match-${index + 1}`}
              snRight={'.next-match'}
              date={match.scheduledAt}
              liveEvents={liveEventsMap[match.id]}
              liveScore={liveScoresMap[match.id]}
              path={path}
              liveEvents={liveEventsMap[match.id]}
              liveScore={liveScoresMap[match.id]}
            />  
          )}
        </div>
      )
    })
  }

  renderNextMatch(nextMatchId, nextMatches) {
    const { path, liveEventsMap = {}, liveScoresMap = {} } = this.props
    if (nextMatchId) {
      const nextMatch = (nextMatches || []).find(item => item && item.id === nextMatchId) || null
      return nextMatch ? (
        <div className='eliminatorias-content__match-wrapper'>
          <CardPartido
            time={nextMatch.time}
            timezone={nextMatch.timezone}
            homeTeam={nextMatch.homeTeam}
            awayTeam={nextMatch.awayTeam}
            matchId={nextMatch.id}
            venue={nextMatch.venue}
            status={nextMatch.status}
            scheduledAt={nextMatch.scheduledAt}
            broadcast={nextMatch.broadcast}
            matchProgress={nextMatch.matchProgress}
            customClass={'next-match'}
            snLeft={'.main-match-1'}
            date={nextMatch.scheduledAt}
            liveEvents={liveEventsMap[nextMatch.id]}
            liveScore={liveScoresMap[nextMatch.id]}
            path={path}
            liveEvents={liveEventsMap[nextMatch.id]}
            liveScore={liveScoresMap[nextMatch.id]}
          />  
        </div>
      ) : (
        <div className='eliminatorias-content__match-wrapper'>
          <CardPartido />  
        </div>
      )
    } else {
      return (
        <div className='eliminatorias-content__match-wrapper'>
          <CardPartido />  
        </div>
      )
    }
  }

  render () {
    const { phase = '', nextPhase = '', matches = [], nextMatches = [] } = this.props

    const commonNextMatchId = getCommonNextMatchId(matches)

    return (
      <div className='eliminatorias-content'>
        {/* ── Horizontal lines ── */}
        <div className='eliminatorias-content__line-horizontal--first'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea', '')} />
        </div>
        <div className='eliminatorias-content__line-horizontal--second'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea', '')} />
        </div>

        {/* ── Left column ── */}
        <div className='eliminatorias-content__col eliminatorias-content__col--left'>
          <div className='eliminatorias-content__col-header'>
            <span className='eliminatorias-content__col-title'>{this.getTitles('left', phase)}</span>
          </div>
          <div className='eliminatorias-content__matches'>
            { this.renderMatches(matches) }
          </div>
        </div>

        {/* ── Bracket ── */}
        <div className='eliminatorias-content__bracket'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_corchete', '')} />
        </div>

        {/* ── Right column ── */}
        <div className='eliminatorias-content__col eliminatorias-content__col--right'>
          <div className='eliminatorias-content__col-header'>
            <span className='eliminatorias-content__col-title'>{this.getTitles('right', phase)}</span>
          </div>
          { this.renderNextMatch(commonNextMatchId, nextMatches) }
        </div>

        {/* ── Horizontal line ── */}
        <div className='eliminatorias-content__line-horizontal--last'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea', '')} />
        </div>
      </div>
    )
  }
}

export default EliminatoriasContent



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/EliminatoriasContent/index.jsx